export default [
  {
    path: '/sichuan',
    name: "sichuan",
    component: () => import('@/views/sichuan/start.vue'),
    children: [
      {
        path: 'marconfirmflow',
        name: "scMarConfirmFlow",
        component: () => import('@/views/sichuan/marconfirmflow.vue'),
        meta: {
          title: '四川移动用户专享'
        }
      },
      {
        path: 'marsecconfirmflow',
        name: "scMarSecConfirmFlow",
        component: () => import('@/views/sichuan/marsecconfirmflow.vue'),
        meta: {
          title: '四川移动用户专享'
        }
      },
      {
        path: 'flow',
        name: "sichuanFlow",
        component: () => import('@/views/sichuan/flow.vue'),
        meta: {
          title: '四川移动用户专享'
        }
      },
      {
        path: 'flowconfirm',
        name: "sichuanFlowConfirm",
        component: () => import('@/views/sichuan/flowConfirm.vue'),
        meta: {
          title: '四川移动用户专享'
        }
      },
      {
        path: 'success',
        name: "sichuanSuccess",
        component: () => import('@/views/sichuan/success.vue'),
        meta: {
          title: '四川移动用户专享'
        }
      },
      {
        path: 'protocol',
        name: "sichuanProtocol",
        component: () => import('@/views/sichuan/protocol.vue'),
        meta: {
          title: '四川移动通信业务办理须知'
        }
      }
    ]
  }
]